"use strict";

$(document).ready(function () {
  var ucldArray = document.getElementsByClassName("urgent-care-location-detail");
  if (ucldArray.length > 0) {
    Array.from(ucldArray).forEach(function (el) {
      var listControls = el.getElementsByClassName("slot-list-control");
      if (listControls.length > 0) {
        Array.from(listControls).forEach(function (listControl) {
          listControl.addEventListener("click", function (event) {
            event.preventDefault();
            var targetExpanded = event.target.getAttribute("aria-expanded");
            if (targetExpanded == "true") {
              event.target.setAttribute("aria-expanded", "false");
              event.target.innerHTML = "View All";
            } else {
              event.target.setAttribute("aria-expanded", "true");
              event.target.innerHTML = "View Less";
            }
          });
        });
      }
    });
  }
});